export enum UpdateRwaBalanceType {
    Treasury = 'Treasury',
    Commission = 'Commission'
}

export const UpdateRwaBalanceTypes = Object.values(UpdateRwaBalanceType);